import {cs}       from "./chain-services";
import {Link}     from "./cst2";
import {toState}  from "./to-state";
import {UseState} from "./use-state";

export const KeyedState = <T,>({_key, defaultValue, next}:{
    _key         : string,
    defaultValue : T,
    next         : Link<JSX.Element, {
        onChange : (v:T) => void,
        value    : T,
    }>,
}) => cs(
    ["state", (_, next) => UseState({next})],
    ({state}) => {
        const calValue = (v1) => v1 && v1._key === _key ? v1.value : defaultValue;
        return next(toState({
            value: calValue(state.value),
            change: (fn) => state.change((v1) => ({_key, value: fn(calValue(v1))})),
        }));
    },
);

